import React, { useState, useEffect } from 'react'
import { createRoot } from 'react-dom/client';
import { DropdownDate } from 'react-dropdown-date';
import Fade from "react-reveal/Fade";
import { Dropdown } from 'primereact/dropdown';
import PrimeReact from 'primereact/api';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Password } from 'primereact/password';
import '../site/scss/_register.scss';
const axios = require('axios').default;
// import { InputMask } from 'primereact/inputmask';
// import { PatternFormat } from 'react-number-format';

PrimeReact.zIndex = {
  overlay: 99999,
}

class RegisterForm extends React.Component {

  constructor(props) {

    const today = new Date();
    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    const eighteenDob = eighteenYearsAgo.toISOString().split('T')[0];
    super(props);
    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      address_1: '',
      address_2: '',
      city: '',
      state: '',
      zip:'',
      addressMsg: '',
      phone: '',
      dob: eighteenDob,
      dobStart: eighteenDob,
      dateChanged: false,
      country: 'United States',
      password: '',
      tos: false,
      emailError: null,
      formMissing: '',
      formValid: false,
      formSubmitted: false,
      step: 1,
      subscibed: false,
    }
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSteps = this.handleFormSteps.bind(this);
    this.handleAddressSelection = this.handleAddressSelection.bind(this);
  }

  handleAddressSelection = (inputValue) => {
    this.setState({
      address_1: inputValue.street,
      address_2: inputValue.street_2,
      city: inputValue.city,
      state: inputValue.state,
      zip: inputValue.zip,
    });
    this.validateForm();
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.setState({formSubmitted: true});
    let form_data = new FormData;
    form_data.append('action', 'ww_register_user');
    form_data.append('data', JSON.stringify(this.state));
    return axios.post('/wp-admin/admin-ajax.php', form_data).then(response => {
      if (response.data === 'success') {
        if (document.cookie.indexOf('h2h_oid') > -1) {
          const cookie = document.cookie.split('; ').find(row => row.startsWith('h2h_oid='));
          const oid = cookie.split('=')[1];
          window.location.href = "/board/?h2h="+oid;
        } else {
          window.location.href = "/board/?reg=1";
        }
      } else {
        this.setState({formValid: false});
        this.setState({formMissing: response.data});
        this.setState({formSubmitted: false});
      }
    });
  }

  handleInputChange(e) {
    const { name, value } = e.target;

    this.setState({ [name]: value });

    if (name === 'tos') {
      this.setState({tos: !this.state.tos});
    }

    if (name === 'email') {
      let validEmail = this.isValidEmail(value);
      if (!validEmail) {
        this.setState({'emailError':'A valid email will be required.'});
      } else {
        this.setState({'emailError':null});
      }
    }

    if (name === 'state') {
      let regulated = ['AL', 'AZ', 'CO', 'DE', 'IN', 'IA', 'LA', 'ME', 'MD', 'MA', 'MI', 'MS', 'NH', 'NJ', 'NY', 'OH', 'PA', 'SD', 'TN', 'VT', 'VA', 'WV'];
      let h2hOnly = ['AL', 'FL', 'IL','KS', 'NH', 'WV', 'WY', 'KY']
      let blockedStates = ['HI', 'ID', 'MT', 'NV', 'WA'];
      if (blockedStates.includes(value)) {
        this.setState({addressMsg: 'Unfortunately ' + value + ' does not allow DFS. You may still do free play and win gift cards.'});
      } else if (h2hOnly.includes(value)) {
        this.setState({addressMsg: 'Note: ' + value + ' is limited to peer-to-peer (H2H) play.'});
      } else if (regulated.includes(value)) {
        this.setState({addressMsg: value + ' winnings are limited to gift card prizes.'});
      } else {
        this.setState({addressMsg: ''});
      }
    }

    // if (name === 'phone') {
    //   let val = value.replace(/\D/g, '');
    //   if (val.length > 11) {
    //     val = val.slice(0, 11);
    //   }
    //   this.setState({phone: val});
    // }

    this.validateForm();
  }

  isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  async sendToOmniSend() {

    if (this.state.subscibed) {
      return;
    }

    try {
      const response = await fetch('https://api.omnisend.com/v5/contacts', {
        method: 'POST',
        headers: {
          'X-API-KEY': '65c982ae6b8dbf22945a2bd4-uUbP9U11BQM1cuXTFNDMPJAZDi0sMAMcI1JbIkQ3jB5IsxhtHM',
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          sendWelcomeEmail: true,
          identifiers: [
            {
              type: 'email',
              channels: {
                email: {
                  status: 'subscribed',
                  statusDate: new Date().toISOString().replace(/\.\d{3}/, ''),
                },
              },
              consent: {
                createdAt: new Date().toISOString().replace(/\.\d{3}/, ''),
                source: "Registration form",
                userAgent: navigator.userAgent,
              },
              id: this.state.email,
            },
          ],
        }),
      });

      if (response.ok) {
        this.setState({subscibed: true});
      } else {
        console.error('Error during email validation and subscription:', response);
      }

    } catch (error) {
      // If there was an error in the request, log it and return false
      console.error('Error during email validation and subscription:', error);
    }
  }

  validateForm() {
    setTimeout( () => {
      let msg = '';

      if (!this.state.tos) {
        msg = 'You must agree to the Terms of Service to continue';
      }

      if (!this.state.password) {
        msg = 'Add a password to continue';
      }

      if (!this.state.dateChanged) {
        msg = 'Add your Date of Birth to continue';
      }

      if (this.state.dateChanged) {
        // check age
        let today = new Date();
        let age = today.getFullYear() - this.state.dob.getFullYear();
        let nineteenBlock = age < 19 && ['AL', 'NE'].includes(this.state.state);
        let twentyOneBlock = age < 21 && ['AZ', 'IA', 'LA', 'MA'].includes(this.state.state);
        if (nineteenBlock || twentyOneBlock) {
          let age = nineteenBlock ? 19 : 21;
          msg = this.state.state + ' requires you to be '+age+' to play';
        }
      }

      if (!this.state.address_1) {
        msg = 'Add your Address to continue';
      }

      if (!this.state.city) {
        msg = 'Add your City to continue';
      }

      if (!this.state.state) {
        msg = 'Add your State to continue';
      }

      if (!this.state.zip) {
        msg = 'Add your Zip to continue';
      }

      if (!this.state.country) {
        msg = 'Add your Country to continue';
      }

      if (this.state.lastName.length < 1) {
        msg = 'Add your Last name to continue';
      }

      if (this.state.firstName.length < 1) {
        msg = 'Add your First name to continue';
      }

      if (!this.state.email || !this.isValidEmail(this.state.email)) {
        msg = 'Add a valid email to continue';
      }

      // if (this.state.phone.length !== 11) {
      //   msg = 'Add a valid phone number to continue (10 digits)';
      // }

      // if (this.state.phone[0] !== '1') {
      //   msg = 'Phone number must start with 1.';
      // }

      this.setState({formMissing: msg});
      this.setState({formValid: msg.length === 0});

    }, 100);

  }

  handleLoginModal() {
    $('[data-dismiss=modal]').trigger({ type: 'click' });
    $('.lrm-login').trigger({ type: 'click' });
    $('[data-dismiss=modal]').trigger({ type: 'touchend' });
    $('.lrm-login').trigger({ type: 'touchend' });
  }

  handleFormSteps(direction) {
    event.preventDefault();
    let isNext = direction === 'next';

    // Validate current step
    if (isNext && this.state.step === 1) {
      if (!this.state.email || !this.state.firstName || !this.state.lastName) {
        return;
      } else {
        this.sendToOmniSend();
      }
    }

    if (isNext && this.state.step === 2) {
      if (!this.state.address_1 || !this.state.city || !this.state.state || !this.state.zip) {
        return;
      }
    }

    let change = isNext ? this.state.step + 1 :this.state.step - 1;
    this.setState({ step: change });
  }

  render() {
    return(
      <div className="register-container">
        <form className="register-form" onSubmit={this.onFormSubmit}>
          {this.state.step === 1 &&
            <Fade>
            <div className="alert alert-success" role="alert">Promo Active: Received on first deposit.</div>
            <div className='row'>
              <label className='col-12' htmlFor="email">
              <div className='reg-header'>Email</div>
              <p>This will be used as your login</p>
              <input id="email" name="email" type='text' value={this.state.email} onChange={this.handleInputChange} autoComplete="email" />
              {this.state.emailError && <p style={{color: 'red'}}>{this.state.emailError}</p>}</label>
            </div>

            <div className='row mt-4'>
              <label className='col-12'>
                <div className='row'>
                  <div className='col-6'>
                    <label htmlFor="firstName">
                      <div className='reg-header'>Legal First Name</div>
                      <input id="firstName" name="firstName" value={this.state.firstName} onChange={this.handleInputChange} autoComplete="given-name" />
                    </label>
                  </div>
                  <div className='col-6'>
                    <label htmlFor="lastName">
                      <div className='reg-header'>Legal Last Name</div>
                      <input id="lastName" name="lastName" value={this.state.lastName} onChange={this.handleInputChange} autoComplete="family-name" />
                    </label>
                  </div>
                </div>

              </label>
            </div>

            <div className='row mt-3'>
              <div className="col-6 text-left"><a href='#' id='url-link' onClick={this.handleLoginModal}>Have an Account?</a></div>
              <div className='col-6'>
                <button onClick={() => this.handleFormSteps('next')} className={"form-next-btn" + (this.state.firstName && this.state.lastName && this.state.email ? ' active' : '')}>Next</button>
              </div>
            </div>
            </Fade>
          }

          {this.state.step === 2 &&
            <Fade>
              <div className='row'>
                <label className='col-12'>
                  <div className='reg-header'>Your Address
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>

                  {/* <AddressAutoComplete
                    handleAddressSelection={this.handleAddressSelection.bind(this)}
                  /> */}

                  <div className='row mt-3'>
                    <div className='col-6'>
                      <label className='col-12' htmlFor="address_1">
                        <p>Street</p>
                        <input id="address_1" name="address_1" autoComplete="address-line1" value={this.state.address_1} onInput={this.handleInputChange} />
                      </label>
                    </div>
                    <div className='col-6'>
                      <label className='col-12' htmlFor="address_2">
                        <p>Suite or Apt. #</p>
                        <input id="address_2" name="address_2" autoComplete="address-line2" value={this.state.address_2} onInput={this.handleInputChange} />
                      </label>
                    </div>
                  </div>

                  <div className='row mt-2'>
                    <div className='col-6'>
                      <label className='col-12' htmlFor="city">
                        <p>City</p>
                        <input id="city" name="city" autoComplete="address-level2" value={this.state.city} onInput={this.handleInputChange} />
                      </label>
                    </div>
                    <div className='col-6'>
                      <label className='col-12' htmlFor="state">
                        <p>State</p>
                        <select id="state" name="state" autoComplete="address-level1" value={this.state.state} onChange={this.handleInputChange}>
                          <option value="">Select state</option>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>
                      </label>
                    </div>
                  </div>

                  <div className='row mt-2'>
                    <div className='col-6'>
                      <label className='col-12' htmlFor="zip">
                        <p>Zipcode</p>
                        <input id="zip" name="zip" autoComplete="postal-code" value={this.state.zip} onInput={this.handleInputChange} />
                      </label>
                    </div>
                    <div className='col-6'>
                      <label className='col-12' htmlFor="country">
                        <p>Country</p>
                        <input id="country" name="country" autoComplete="country" value={this.state.country} onInput={this.handleInputChange} />
                      </label>
                    </div>
                  </div>
                </label>
              </div>

            {this.state.addressMsg &&
              <div className='row mt-3'>
                <div className='col-12 error-msg'><b>{this.state.addressMsg}</b>
                </div>
              </div>}


              <div className='row mt-3'>
                <div className='col-6'>
                  <button onClick={() => this.handleFormSteps('prev')} className='form-prev-btn'>Previous</button>
                </div>
                <div className='col-6'>
                  <button onClick={() => this.handleFormSteps('next')} className={"form-next-btn" + (this.state.address_1 && this.state.city && this.state.state && this.state.zip ? ' active' : '')}>Next</button>
                </div>
              </div>

            </Fade>
          }

          {this.state.step === 3 &&
            <Fade>
              <div className='row'>
              <label className='col-12'>
                <div className='reg-header'>Date of Birth</div>
                <p className="mb-2">Let's verify you're old enough to play</p>
                <DropdownDate
                  startDate={'1950-01-01'}
                  endDate={this.state.dobStart}
                  defaultValues={{
                    year: 'Year',
                    month: 'Month',
                    day: 'Day'
                  }}
                  selectedDate={this.state.dob}
                  onDateChange={(date) => {
                    this.setState({ dob: date, dateChanged: true });
                    this.validateForm();
                  }}
                  classes={{
                    dateContainer: 'row',
                    yearContainer: 'col-4',
                    monthContainer: 'col-4',
                    dayContainer: 'col-4'
                  }}
                  options={{yearReverse: true}}
                />
                </label>
              </div>

              {/*
              <div className='row mt-4'>
                <label className='col-12'>
                  <div className='reg-header'>Phone #</div>
                  <p className="mb-2">Required for Rapid Withdrawals & Deposits</p>
                  <PatternFormat format="+1 (###) ### ####" id="phone" name="phone" onChange={this.handleInputChange} autocomplete="tel" placeholder="+1 (999) 999-9999" type="tel" />
                </label>
              </div> */}

              <div className='row mt-4'>
              <label htmlFor="password" className='col-12'>
                <div className='reg-header w-100'>Password</div>
                <Password id="password" name="password" value={this.state.password} onChange={this.handleInputChange} toggleMask />
                </label>
              </div>

                <div className='row mt-4'>
                  <label className='col-12'>
                    <div className='reg-header'>Resident Verification</div>
                    <p>Due to State regulations, we will require proof of identity to play DFS.</p>
                  </label>
                </div>


              <div className='row mt-3'>
              <label htmlFor="tos">
                <div className='reg-header mt-4'><input id="tos" name="tos" type='checkbox' checked={this.state.tos} onChange={this.handleInputChange} />Terms of Service</div>
                <p className="tos">Check here if you agree to our <a href='/terms-of-use'>Terms of use</a> and <a href='/privacy-policy'>Privacy Policy</a>. This also confirms you are of legal age to participate in contests on WagedWar.com</p></label>
              </div>

              <div className='row mt-3'>
                <div className='col-6'>
                  <button onClick={() => this.handleFormSteps('prev')} className='form-prev-btn'>Previous</button>
                </div>
              </div>

              <div className='row'>
                <div className='col-12 mt-5 mb-2'>
                  {this.state.formValid && !this.state.formSubmitted &&
                    <button type="submit" className="form-btn-submit">LETS PLAY!</button>
                  }

                  {this.state.formSubmitted &&
                    <div className="text-center"><i className="pi pi-spin pi-spinner"></i></div>
                  }

                  {this.state.formMissing.length > 0 && !this.state.formSubmitted &&
                    <div className='error-msg'>{this.state.formMissing}</div>
                  }
                </div>
              </div>

            </Fade>
          }
        </form>
      </div>
    )
  }
}


function AddressAutoComplete( {handleAddressSelection} ) {
  const [inputValue, setInputValue] = useState('');
  const [addresses, setAddresses] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      callSmarty();
    }, 500);

    return () => clearTimeout(timer)
  }, [inputValue]);

  const callSmarty = () => {
    if (typeof inputValue === 'object') {
      // Update fields with selection
      handleAddressSelection(inputValue);
      return;
    }

    if (inputValue.length < 5) return;
    document.getElementsByClassName('spinner-border')[0].style.display = 'inline-block';
    let form_data = new FormData;
    form_data.append('address', inputValue);
    form_data.append('action', 'call_smarty_autocomplete');
    axios.post('/wp-admin/admin-ajax.php', form_data).then(response => {
      document.getElementsByClassName('spinner-border')[0].style.display = 'none';
      setAddresses(response.data);
      document.getElementsByClassName("p-dropdown-trigger")[0].click();
    });
  }

  return (
        <div className="card flex justify-content-center">
          <Dropdown
            value={inputValue}
            onChange={(e) => setInputValue(e.value)}
            options={addresses}
            optionLabel="name"
            placeholder="Start typing to Autofill Address"
            className="w-full md:w-14rem"
            editable
          />
      </div>
  )
}

const container = document.getElementById('register-form');
if (container !== null) {
  const root = createRoot(container);
  root.render(<RegisterForm />);
}
